export default "__VITE_ASSET__Hbqaqaks__"